module.exports = __webpack_public_path__ + "img/nekludova.eb13d40d.jpg";